import {ChangeDetectionStrategy, Component, computed, input} from '@angular/core';
import {NgTemplateOutlet} from '@angular/common';
import {RouterLink} from '@angular/router';
import {TippyDirective} from '../../../tippy.directive';
import {FormatDatePipe} from '../../../pipes/format-date.pipe';
import {FormatNumberPipe} from '../../../pipes/format-number.pipe';
import {FormatUnitPipe} from '../../../pipes/format-unit.pipe';
import {Tile, TILE_DOT, TileProgressBar} from '../../models/tile';

/**
 * A statistics tile — see {@link Tile} for what a tile can hold. Usually placed by `app-tile-grid`
 * rather than used directly. The card's geometry lives entirely in `_tile.scss`.
 */
@Component({
  selector: 'app-tile',
  imports: [RouterLink, NgTemplateOutlet, TippyDirective, FormatDatePipe, FormatNumberPipe, FormatUnitPipe],
  templateUrl: './tile.component.html',
  styleUrl: './tile.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TileComponent {
  readonly tile = input.required<Tile>();

  /**
   * Makes the whole card a single link rather than showing the corner arrow. Needs `tile.nav`;
   * without it the tile stays inert either way.
   */
  readonly clickableTile = input(false);

  protected readonly dot = TILE_DOT;

  /** The app's tooltip look, for the ⓘ description and the multi-segment progress bar's breakdown. */
  protected readonly tooltipOptions = {
    theme: 'pozi',
    placement: 'top',
    appendTo: document.body
  };

  /** Normalised to an array, so the template does not branch on the single-bar shorthand. */
  protected readonly progressBar = computed<TileProgressBar[]>(() => {
    const progressBar = this.tile().progressBar;
    if (!progressBar) {
      return [];
    }
    return Array.isArray(progressBar) ? progressBar : [progressBar];
  });
}
